import { Currency, DateFormat, Languages } from '@dark-portal/backend-planora';
import { identityStore } from '@dark-portal/frontend-identity/src/features/app/features/identity/store/store';
import { ApiRequestError, ApiStatus } from '@dark-portal/react-infrastructure';
import i18n from 'i18next';

import { getDefaultCurrencyBasedOnLang } from '@/src/features/_infrastructure/currency/getDefaultCurrencyBasedOnLang';
import { getDefaultDateFormatBasedOnLang } from '@/src/features/_infrastructure/date/getDefaultDateFormatBasedOnLang';
import { UsersApi } from '@/src/features/api/users.api';
import { APP } from '@/src/features/app/app.constants';
import { router } from '@/src/features/app/features/content/features/Router';
import { UserConfigurationStatus, userConfigurationStore } from '@/src/features/app/store/userConfiguration/store';

export async function fetchUser(): Promise<void> {
  const { updateStatus, updateRegistered, updateUser } = userConfigurationStore.getState();

  try {
    updateStatus(UserConfigurationStatus.Loading);

    const { request } = UsersApi.getMe();
    const response = await request;
    const user = response.data;

    updateUser({
      username: user.username,
      discriminator: user.discriminator,
      language: user.language as Languages,
      currency: user.currency as Currency,
      dateFormat: user.dateFormat as DateFormat,
      contactLanguage: user.contactLanguage as Languages,
      contactPhone: user.contactPhone ?? undefined,
      contactEmail: user.contactEmail ?? undefined,
    });
    updateStatus(UserConfigurationStatus.Idle);
    updateRegistered(true);
  } catch (error) {
    updateRegistered(false);

    if (error instanceof ApiRequestError && error.status === ApiStatus.NotFound) {
      const email = identityStore.getState().user?.email;
      const language = i18n.language as Languages;

      updateUser({
        username: email?.split('@')?.[0] ?? '',
        discriminator: '',
        language,
        currency: getDefaultCurrencyBasedOnLang(),
        dateFormat: getDefaultDateFormatBasedOnLang(),
        contactLanguage: language,
        contactPhone: undefined,
        contactEmail: email,
      });

      updateStatus(UserConfigurationStatus.Idle);
      void router.navigate(APP.ROUTES.SETTINGS);
    } else {
      updateStatus(UserConfigurationStatus.Error);
    }
  }
}
